<template>
  <Transition
    enter-active-class="tw:transition-opacity tw:duration-150"
    enter-from-class="tw:opacity-0"
    leave-active-class="tw:transition-opacity tw:duration-150"
    leave-to-class="tw:opacity-0"
  >
    <div
      v-show="isDrawerVisible"
      ref="aiDrawerRef"
      class="tw:flex tw:bg-[rgba(0,0,0,0.64)] tw:justify-end tw:fixed tw:h-full tw:w-full tw:top-0 tw:right-0 tw:m-0 tw:user-drag-none tw:container-type-inline-size edrone-drawer-backdrop tw:z-[99999999]"
      @mousedown="closeDrawer"
    >
      <Transition
        enter-active-class="tw:transform tw:transition-transform tw:duration-700 tw:ease-in-out"
        enter-from-class="tw:translate-x-full"
        enter-to-class="tw:translate-x-0"
        leave-active-class="tw:transform tw:transition-transform tw:duration-700 tw:ease-in-out"
        leave-from-class="tw:translate-x-0"
        leave-to-class="tw:translate-x-full"
      >
        <div
          v-show="isContentVisible"
          :style="`width: 35rem !important`"
          class="tw:h-full tw:p-0 tw:relative tw:right-0 tw:w-full tw:bg-white"
        >
          <EdroneNavigationTop
            :show-close-icon="true"
            class="tw:border-b tw:border-b-default-200"
            type="drawer"
            @close="emit('close')"
          >
            <template #header>
              <div class="tw:flex tw:items-center tw:gap-2">
                <EdroneHeader :title="trans.header.title" type="h2" />
              </div>
            </template>
          </EdroneNavigationTop>
          <AiBannerContent :is-open="isOpen" />
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import AiBannerContent from "./AiBannerContent.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import EdroneNavigationTop from "edrone-components/EdroneNavigationTop.vue";
import { ref, Ref, watch, nextTick } from "vue";
import { hideIntercomChat, updateIntercom } from "vue-app/utils/functions.ts";

interface Props {
  isOpen: boolean;
}

interface Emits {
  (event: "close"): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const trans = window._trans._branding.aiBanner;

const aiDrawerRef: Ref<HTMLElement | null> = ref(null);
const isDrawerVisible = ref(props.isOpen);
const isContentVisible = ref(props.isOpen);

watch(
  () => props.isOpen,
  async (isOpen) => {
    if (isOpen) {
      isDrawerVisible.value = isOpen;
      await nextTick();
      isContentVisible.value = isOpen;
      hideIntercomChat();
      updateIntercom("hide_default_launcher", true);
    } else {
      isContentVisible.value = isOpen;
      setTimeout(() => {
        isDrawerVisible.value = isOpen;
        updateIntercom("hide_default_launcher", false);
      }, 700); // Same as drawer slide animation duration
    }
  }
);

function closeDrawer(e: MouseEvent) {
  if (e.target === aiDrawerRef.value) {
    emit("close");
  }
}
</script>
